import {
  ContractHonorariumBulkResultDTO,
  ContractHonorariumSkipReason,
} from '../../../dto/contractHonorarium/ContractHonorariumDTO'

const SKIP_REASON_LABELS: Record<ContractHonorariumSkipReason, string> = {
  EXPIRED: 'vencidas',
  ENDS_BEFORE_DATE: 'terminan antes de la fecha',
  FUTURE: 'futuras (se eliminan, no se cierran)',
  NO_CHANGES: 'sin cambios',
}
const SKIP_REASON_ORDER: ContractHonorariumSkipReason[] = ['EXPIRED', 'ENDS_BEFORE_DATE', 'FUTURE', 'NO_CHANGES']

export function describeBulkResult(result: ContractHonorariumBulkResultDTO): string {
  const modified = result.modified === 0
    ? 'No se modificó ninguna distribución'
    : result.modified === 1
      ? '1 distribución modificada'
      : `${result.modified} distribuciones modificadas`
  if (result.skipped === 0) return modified

  const reasons = SKIP_REASON_ORDER
    .filter((reason) => result.skippedByReason[reason])
    .map((reason) => `${result.skippedByReason[reason]} ${SKIP_REASON_LABELS[reason]}`)
    .join(', ')
  const skipped = result.skipped === 1 ? '1 omitida' : `${result.skipped} omitidas`
  return `${modified}. ${skipped}: ${reasons}`
}
